import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { CommonStyles } from '../../styles/Styles';
import TextField from '@material-ui/core/TextField';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import momentTz from 'moment-timezone';
import moment from 'moment';
import FormHelperText from '@material-ui/core/FormHelperText';
import { ValidationHelper } from '../../common/helpers/ValidationHelper';
import { ImageComponent } from './ImageComponent';
import { Helper } from '../../common/helpers/Helper';
export class DateComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    }
  }

  onTimeChange = (e, key) => {
    this.setState({ value: moment(e).valueOf() });
    this.props.handleState(key, moment(e).valueOf());
  }

  render() {
    return (
      <div className={css(CommonStyles.outerContainer)} >
        <div>
          {this.props.mainTitle &&
            <div className={css(CommonStyles.questionMainTitleContainer)}>
              <p className={css(CommonStyles.questionMainTitle)}>{this.props.mainTitle}</p>
              {this.props.showInformationPopup &&
                <div className={css(CommonStyles.questionDetailContainer)} onClick={() => this.props.showInformationPopup(this.props.data)}>
                  <p className={css(CommonStyles.questionDetailContent)}>i</p>
                </div>
              }
            </div>
          }
          {this.props.data.subTitle &&
            <p className={css(CommonStyles.questionSubTitle)}>{this.props.data.subTitle}</p>
          }
        </div>
        {this.props.data.image &&
          <div className={css(CommonStyles.outerImageContainer)}>
            <ImageComponent data={this.props.data} />
          </div>
        }
        <div className={css(this.props.survey ? Styles.innerContainer : CommonStyles.innerContainer)}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className={css(Styles.selectOuterContainer)}>
              <KeyboardDatePicker
                disableFuture={this.props.disableFuture ? this.props.disableFuture : false}
                key={this.props.data.id}
                disabled={this.props.disabled}
                name={this.props.data.id}
                className={this.props.disabled ? css(CommonStyles.textFieldDisabled) : css(CommonStyles.textField)}
                value={this.state.value ? momentTz(this.state.value) : null}
                onChange={e => this.onTimeChange(e, this.props.data.id)}
                //placeholder='Date'
                placeholder='MM/DD/YYYY'
                openTo='year'
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: this.props.disabled ? css(CommonStyles.textFieldContentInputDisabled) : css(CommonStyles.textFieldContentInput)
                  }
                }}
                helperText=''
                format='MM/dd/yyyy'
              />
              <FormHelperText
                className={css(CommonStyles.errorMsgStyle)}>
                {!this.props.enableValidation ? '' : ValidationHelper.validateFields(this.props.data, this.state.value)}
              </FormHelperText>
            </div>
          </MuiPickersUtilsProvider>
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  innerContainer: {
    marginTop: 10,
    marginLeft: 20,
    width: '35%',
    '@media (max-width: 767px)': {
      marginLeft: 10,
      width: '96%'
    }
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/DateComponent.js